/**
 * Error Routes
 *
 * NOTE: This is not live of staging or production.
 * You will see these routes locally, but the Everest migration of error routes has not happened.
 *
 */

import { RouteRecordRaw } from 'vue-router';
import GenericError from '@/components/generic_error/GenericError.vue';

const errorRoutes = [
  {
    path: '/error',
    name: 'Error',
    component: GenericError,
    props: {
      title: 'Something went wrong',
      buttonValue: 'Home',
      buttonHref: '/',
      layout: 'centered',
    },
  },
  {
    path: '/something-went-wrong',
    name: 'SomethingWentWrong',
    component: GenericError,
    props: {
      title: 'Something went wrong',
      buttonValue: 'Try again',
      layout: 'centered',
    },
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'CatchAll',
    component: GenericError,
    props: {
      title: 'Page not found',
      buttonValue: 'Go home',
      buttonHref: '/',
      layout: 'centered',
    },
  },
] as RouteRecordRaw[];

export default errorRoutes;
